// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__QMqXN","title":"FrontImage_title__3c_UV"};